/*----- Core -----*/
import React from 'react'

/*----- Ant design -----*/
import { Row, Col } from 'antd'

/*----- Components -----*/ 
import SectionContainer  from '../../components/commons/SectionContainer'
import HeroParagraph     from '../../components/hero/HeroParagraph'
import AttributeList 		 from '../../components/attributes_list/AttributeList'

/*----- Styles -----*/
import Styles from './Styles'

/*----- Assets -----*/
import Ilustration from '../../assets/contact/contact_ilustration.svg'
import DoubleArrow from '../../assets/icons/double_arrow.svg'

/*----- Utils -----*/
import ScrollTop from '../../utils/ScrollTop'

/*----- Sections -----*/
import ContactForm from './section/ContactForm'

/*----- Export -----*/
const Contact = (props) => {
	ScrollTop()
  return (
		<Styles>

			<SectionContainer>
				<Row type="flex" justify="start" align="top">
					<Col xs={24} sm={24} md={24} lg={12} xl={12}>
						<Row type="flex" justify="center" align="top">
							<img src={Ilustration} alt="" className="illustration__image"/>
						</Row>
						<Col xs={0} sm={0} md={0} lg={24} xl={24} xxl={24}>
							<Row type="flex" justify="center" align="top" className="illustration__paragraph">
								<p>¿Por qué ser parte del equipo de productores y productoras de LB?</p>
								<img src={DoubleArrow} alt=""/>
							</Row>
						</Col>
					</Col>
					<Col xs={24} sm={24} md={24} lg={12} xl={12}>
					<HeroParagraph title="Sumate a nuestra organización como productor/a" />
						<Row type="flex" justify="start" align="middle">
							<div className="contact-form-container">
								<ContactForm />
							</div>
						</Row>
					</Col>
				</Row>
			</SectionContainer>

			<Col xs={24} sm={24} md={24} lg={0} xl={0} xxl={0}>
				<Row type="flex" justify="center" align="top" className="illustration__paragraph">
					<p>¿Por qué ser parte del equipo de productores y productoras de LB?</p>
					<img src={DoubleArrow} alt=""/>
				</Row>
			</Col>

			<Row className="team-philosophy">
				<SectionContainer>
					<div className="team-philosophy__data-container">
						<AttributeList />
					</div>
				</SectionContainer>
			</Row>

    </Styles>
  )
}
export default Contact